import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/menu/initialStates/menuType_initialState.ts
var MENU_TYPE_INITIAL_STATE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  locationMenuTypeId: 0,
  locationId: 0,
  createdByLocationId: 0,
  name: "",
  posName: "",
  organizationId: 0,
  menuTypeId: 0,
  description: "",
  active: true,
  itemIds: [],
  itemMenuTypeTemplateIds: {},
  categoryIds: [],
  subcategoryIds: [],
  locationMenuTypeVersionId: 0,
  comboIds: [],
  comboMenuTypeTemplateIds: {},
  taxIds: [],
  enableSimpleMode: false,
  homeScreenElements: [],
  comboDisplayName: "Combo",
  hotButtons: {},
  coursingType: "none" /* NONE */,
  defaultToHomeScreen: true
});

export { MENU_TYPE_INITIAL_STATE };
